import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { PageHero, Img, DemoBadge } from "@/components/common";
import useTitle from "@/lib/useTitle";
import { fmtDay } from "@/lib/time";

export default function Noticias() {
  useTitle("Notícias");
  const { data } = useSite();
  return (
    <>
      <PageHero eyebrow="Novidades" title="Notícias" tone="#b45309" image="/img/music.jpg" />
      <ul className="container-x py-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {data.news.map((n) => (
          <li key={n.id}>
            <Link to={`/noticias/${n.slug}`} className="group block" data-testid={`news-card-${n.slug}`}>
              <Img src={n.image} alt="" className="rounded-3xl aspect-[4/3] w-full object-cover" />
              <p className="eyebrow text-slate-500 mt-4">{fmtDay(n.date, false)}</p>
              <h2 className="font-display text-2xl font-bold mt-1 group-hover:text-[var(--leaf)]">{n.title}</h2>
              <p className="text-slate-700 mt-2 line-clamp-2">{n.excerpt}</p>
              <DemoBadge show={n.demo} className="mt-2" />
            </Link>
          </li>
        ))}
        {data.news.length === 0 && <li className="text-slate-600">Sem notícias publicadas.</li>}
      </ul>
    </>
  );
}
